import { useContext } from 'react';
import { SignInContext } from '../context/SignInContextProvider.js';
/**
 * Returns the login site's facade — the only way a sign-in component writes (`requestSignInCode`, `verifySignInCode`,
 * `resendSignInCode`, `submitSignInCode`, `chooseDifferentEmail`, `ensureGoogleSignIn`). None of its methods reject, so callers can fire them with `void`.
 *
 * Takes no parameters.
 *
 * @returns The facade given to the nearest `SignInContextProvider`.
 * @throws Error `useSignInFacade must be used within SignInContextProvider` when called outside a
 * `SignInContextProvider`, so a missing provider fails on first render instead of rendering an empty page.
 */
export function useSignInFacade() {
    const { facade } = useContext(SignInContext);
    if (facade === undefined) {
        throw new Error('useSignInFacade must be used within SignInContextProvider');
    }
    return facade;
}
//# sourceMappingURL=useSignInFacade.js.map